import { isSemrush } from './utils/semrush';

export const SupportLinks = {
  general: {
    helpCenter: 'https://support.crazyegg.com/',
    email: 'support@crazyegg.com',
    newSupportRequest: isSemrush
      ? 'https://www.semrush.com/kb/support'
      : 'https://support.crazyegg.com/?open_modal=contact',
    profileSetting: 'https://auth.app.crazyegg.com/settings',
  },
  abTests: {
    multiArmBanditMethod:
      'https://support.crazyegg.com/knowledge-base/crazy-egg-a-b-tests-guide-to-multi-armed-bandit-testing/',
  },
  install: {
    manual: 'https://support.crazyegg.com/knowledge-base/how-to-manually-install-crazy-egg/',
    drupal7: 'https://support.crazyegg.com/knowledge-base/drupal-8-9-or-10-installation-guide/',
    drupal8: 'https://support.crazyegg.com/knowledge-base/drupal-8-9-or-10-installation-guide/',
    gtm: 'https://support.crazyegg.com/knowledge-base/google-tag-manager-installation-guide/',
    joomla: 'https://support.crazyegg.com/knowledge-base/joomla-installation-guide/',
    magento1: 'https://support.crazyegg.com/knowledge-base/magento-1-installation-guide/',
    magento2: 'https://support.crazyegg.com/knowledge-base/magento-2-installation-guide/',
    shopify: 'https://support.crazyegg.com/knowledge-base/how-to-install-crazy-egg-on-shopify-step-by-step-guide/',
    squarespace: 'https://support.crazyegg.com/knowledge-base/squarespace-installation-guide/',
    wix: 'https://support.crazyegg.com/knowledge-base/wix-installation-guide/',
    wordpress: 'https://support.crazyegg.com/knowledge-base/wordpress-installation-guide/',
  },
  scriptCheck: {
    manual: 'https://support.crazyegg.com/knowledge-base/how-to-check-that-crazy-egg-is-installed/',
    malformedScript: 'https://support.crazyegg.com/knowledge-base/troubleshooting-malformed-script/',
    missingScript: 'https://support.crazyegg.com/knowledge-base/troubleshooting-missing-tracking-script/',
    contentSecurityPolicy: 'https://support.crazyegg.com/knowledge-base/troubleshooting-content-security-policy-csp/',
    duplicateScript: 'https://support.crazyegg.com/knowledge-base/troubleshooting-duplicate-tracking-script-installed/',
    cacheScript: 'https://support.crazyegg.com/knowledge-base/troubleshooting-cache-script/',
    multipleSnapshots: 'https://support.crazyegg.com/knowledge-base/troubleshooting-multiple-snapshots-for-same-page/',
    trackByName: 'https://support.crazyegg.com/knowledge-base/troubleshooting-track-by-name-mismatch-snapshots/',
    noData: 'https://support.crazyegg.com/',
  },
  sessions: {
    visitorIdentifier: 'https://support.crazyegg.com/knowledge-base/visitor-identifier/',
  },
  errors: {
    appVersionTracking: 'https://support.crazyegg.com/knowledge-base/errors-app-version-tracking/',
    crossBrowserTracking: 'https://support.crazyegg.com/knowledge-base/errors-cross-browser-tracking/',
  },
  recordings: {
    autoGeneratedTags: 'https://support.crazyegg.com/knowledge-base/auto-generated-tags-in-recordings/',
    monthlyRecordingsSampling:
      'https://support.crazyegg.com/knowledge-base/how-to-customize-your-recordings-sampling-rate/',
  },
  sso: 'https://support.crazyegg.com/knowledge-base/single-sign-on/',
  script: {
    ce2Functions: 'https://support.crazyegg.com/knowledge-base/custom-user-variables/',
  },
  snapshots: {
    trackByName: 'https://support.crazyegg.com/knowledge-base/track-by-name/',
    wildcardRegex: 'https://support.crazyegg.com/knowledge-base/advanced-tracking-wildcard-or-regular-expression/',
    blockPopUpsOmitSpecificElements:
      'https://support.crazyegg.com/knowledge-base/removing-cookie-consents-or-omit-pop-ups/',
    usingPageCamera: 'https://support.crazyegg.com/knowledge-base/using-page-camera/',
    usingPageCameraForCheckout:
      'https://support.crazyegg.com/knowledge-base/qa-creating-a-snapshot-for-behind-a-login-page-or-checkout-page/',
    recurringSnapshot: 'https://support.crazyegg.com/knowledge-base/recurring-snapshots/',
    error: 'https://support.crazyegg.com/?open_modal=contact',
    export: 'https://support.crazyegg.com/knowledge-base/exporting-multiple-snapshots-from-your-dashboard/',
  },
  installation: 'https://support.crazyegg.com/article-categories/installation-methods/',
  survey: {
    minimumContrast:
      'https://support.crazyegg.com/knowledge-base/will-the-survey-affect-my-website-accessibility-standards/',
    advancedTrigger: 'https://support.crazyegg.com/knowledge-base/triggering-a-survey-via-javascript/',
    zeroViews: 'https://support.crazyegg.com/knowledge-base/why-are-my-views-zero-0/',
    nps: 'https://support.crazyegg.com/knowledge-base/interpreting-nps-results/',
  },
  siteSettings: {
    sessionsTriggeredByJS: 'https://support.crazyegg.com/knowledge-base/track-by-name-for-video-recordings/',
    maskingElement: 'https://support.crazyegg.com/knowledge-base/video-recordings-masking-elements/',
  },
  notifications: {
    create: 'https://support.crazyegg.com/knowledge-base/notifications/',
  },
  webAnalytics: {
    referrers: 'https://support.crazyegg.com/knowledge-base/why-arent-my-subdomains-listed-as-referrers/',
  },
};
